<template>
  <div id="xsjeyzl"></div>
</template>

<script>
// import echarts from "echarts";
import echarts from "echarts";
import { echartDatas } from "@/api/resourceLog"
export default {
  props: {
    xAxisDataOfht: {
      type: Array,
      default: () => {
        return [7,2,3,4,5,6]
      }
    },
    yAxisDocumentarySum: {
      type: Array,
      default: () => {
        return [22,33,44,55,66,77]
      }
    },
    otherInsertCount:{
        type: Array,
      default: () => {
        return [22,33,44,55,66,77]
      }
    }
  },
  data() {
    return {
      color: ["#4a88ff", "#59edbc"],
      chartOption : {
        backgroundColor: "#fff",

        color: this.color,

        legend: {
          left: "right",

          top: 5,
        },

        tooltip: {
          trigger: "axis",

          formatter: function (params) {
            let html = `<div  style="font-size: 12px;color:#999">${params[0].name}<div>`;

            params.forEach((v) => {
              html += `<div style="color: #999;font-size: 12px;line-height: 20px">

                <span style="display:inline-block;border-radius:10px;width:8px;height:8px;background-color:${
                  ["#4a88ff", "#59edbc"][v.componentIndex]
                };"></span>

                ${v.seriesName}

                <span style="color:${
                  ["#4a88ff", "#59edbc"][v.componentIndex]
                };font-weight:700;font-size: 16px;margin-left:5px">${
                v.value
              }</span>

                次`;
            });

            return html;
          },

          extraCssText:
            "background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;",

          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效

            type: "line", // 默认为直线，可选为：'line' | 'shadow'

            lineStyle: {
              color: {
                type: "linear",

                x: 0,

                y: 0,

                x2: 0,

                y2: 1,

                colorStops: [
                  {
                    offset: 0,

                    color: "rgb(255,255,255)", // 0% 处的颜色
                  },

                  {
                    offset: 0.2,

                    color: "#1274EE", // 0% 处的颜色
                  },

                  {
                    offset: 0.5,

                    color: "#1274EE", // 0% 处的颜色
                  },

                  {
                    offset: 0.8,

                    color: "#1274EE", // 0% 处的颜色
                  },

                  {
                    offset: 1,

                    color: "rgb(255,255,255)", // 100% 处的颜色
                  },
                ],

                global: false, // 缺省为 false
              }, // "#1274EE",

              type: "dashed",
            },
          },
        },

        toolbox: {
          show: false,

          left: "right",

          itemSize: 15,

          top: -5,

          feature: {
            dataZoom: {
              yAxisIndex: "none",

              color: "#333",
            },

            restore: {},
          },
        },

        dataZoom: [
          {
            type: "inside",

            throttle: 50,
          },
        ],

        grid: {
          left: "4%",

          right: "5%",

          bottom: "0%",

          containLabel: true,
        },

        xAxis: [
          {
            type: "category",

            boundaryGap: false,

            axisLabel: {
              textStyle: {
                color: "#999",

                fontSize: 10,

                padding: [2, 0, 0, 0],
              },
            },

            axisLine: {
              lineStyle: {
                color: "#E4E4E4",
              },
            },

            data:this.xAxisDataOfht, //[1,2,3,4,5,6],
          },
        ],

        yAxis: [
          {
            type: "value",

            name: "数量/次",

            axisLabel: {
              textStyle: {
                color: "#999",

                fontSize: 12,
              },
            },

            nameTextStyle: {
              color: "#999",

              fontSize: 10,

              lineHeight: 20,
            },

            // 分割线

            splitLine: {
              lineStyle: {
                type: "dashed",

                color: "#E4E4E4",
              },
            },

            axisLine: {
              show: false,
            },

            axisTick: {
              show: false,
            },
          },
        ],

        series: [
          {
            name: "图片资源",

            type: "line",

            smooth: true,

            symbolSize: 6,

            zlevel: 3,

            lineStyle: {
              normal: {
                color: "#4a88ff",

                shadowBlur: 3,

                shadowColor: this.hexToRgba("#4a88ff", 0.5),

                shadowOffsetY: 5,
              },
            },

            symbol: "circle", //数据交叉点样式

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,

                  0,

                  0,

                  1,

                  [
                    {
                      offset: 0,

                      color: this.hexToRgba("#4a88ff", 0.25),
                    },

                    {
                      offset: 1,

                      color: this.hexToRgba("#4a88ff", 0),
                    },
                  ],

                  false
                ),

                shadowColor: "#fff",

                shadowBlur: 10,
              },
            },
            color:'#4a88ff',
            data: this.yAxisDocumentarySum,
          },

          {
            name: "视频资源",

            type: "line",

            smooth: true,

            symbolSize: 6,

            zlevel: 3,

            lineStyle: {
              normal: {
                color: "#59edbc",

                shadowBlur: 3,

                shadowColor: this.hexToRgba("#59edbc", 0.5),

                shadowOffsetY: 5,
              },
            },

            symbol: "circle", //数据交叉点样式 (实心点)

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,

                  0,

                  0,

                  1,

                  [
                    {
                      offset: 0,

                      color: this.hexToRgba("#59edbc", 0.3),
                    },

                    {
                      offset: 1,

                      color: this.hexToRgba("#59edbc", 0),
                    },
                  ],

                  false
                ),

                shadowColor: "#fff",

                shadowBlur: 10,
              },
            },

            color:'#59edbc',
            data: this.otherInsertCount,
          },
        ],
      }
    }
  },
  methods: {
    drawPie(id) {
      
      let myChart = echarts.init(document.getElementById(id));
      myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    hexToRgba(hex, opacity) {
      let rgbaColor = "";

      let reg = /^#[\da-f]{6}$/i;

      if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
          "0x" + hex.slice(3, 5)
        )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
      }

      return rgbaColor;
    },

  },
  watch: {
    yAxisDocumentarySum: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.chartOption.series[0].data = newVal
        this.drawPie("xsjeyzl");
      },
      deep: true
    },
       otherInsertCount: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.chartOption.series[1].data = newVal
        this.drawPie("xsjeyzl");
      },
      deep: true
    },
    xAxisDataOfht: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.chartOption.xAxis[0].data = newVal
        this.drawPie("xsjeyzl");
      },
      deep: true
    },
 
  },
  created(){
  },
  mounted() {
    this.drawPie("xsjeyzl");
    this.$nextTick(function () {});
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#xsjeyzl {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep #xsjeyzl canvas {
  width: 100% !important;
  height: auto !important;
}
</style>
